module.exports = __webpack_public_path__ + "static/media/L-alert.af3f80b6.svg";